import { gql, useLazyQuery } from '@apollo/client';
import { useState } from 'react';
import {
  QueryLoginMethodsArgs,
  LoginMethodsOutput,
} from '@updater/consumer-graph/generated/graphql';

const LOGIN_METHODS = gql`
  query LoginMethods($input: LoginMethodsInput!) {
    loginMethods(input: $input) {
      emailOtp {
        enabled
      }
      password {
        enabled
      }
    }
  }
`;

export function useLoginMethods() {
  const [error, setError] = useState<string | null>(null);

  const [fetchLoginMethods] = useLazyQuery<
    { loginMethods: LoginMethodsOutput | null },
    QueryLoginMethodsArgs
  >(LOGIN_METHODS, { fetchPolicy: 'no-cache' });

  const fetch = async (email: string): Promise<LoginMethodsOutput | null> => {
    setError(null);
    try {
      const result = await fetchLoginMethods({
        variables: { input: { email } },
      });
      if (result.error || !result.data?.loginMethods) {
        setError(
          result.error?.message ?? 'Something went wrong. Please try again.'
        );
        return null;
      }
      return result.data.loginMethods;
    } catch {
      setError('Something went wrong. Please try again.');
      return null;
    }
  };

  return { fetch, error, clearError: () => setError(null) };
}
